'use strict';

const allOrderSpareParts = state => {
  return state.orderSpareParts.slice();
};

export default {
  allOrderSpareParts
};
